"use client";

import {
  Arrow as ReactArrow,
  ArrowDown as ReactArrowDown,
  ArrowLeft as ReactArrowLeft,
  ArrowRight as ReactArrowRight,
  ArrowUp as ReactArrowUp,
  ArrowUpAndRight as ReactArrowUpAndRight,
} from "./deprecated/Arrow";

export const Arrow = ReactArrow;
export const ArrowDown = ReactArrowDown;
export const ArrowLeft = ReactArrowLeft;
export const ArrowRight = ReactArrowRight;
export const ArrowUp = ReactArrowUp;
export const ArrowUpAndRight = ReactArrowUpAndRight;
